import { Directive, Input, HostListener, Output, EventEmitter } from '@angular/core';
import { IExternalUserListItem } from '@core/model';
import { UsersService } from '@core/services';
import { ConfirmationService } from 'primeng/api';

@Directive({
  selector: '[appChangeUserStatusV2]',
  standalone: false
})
export class ChangeUserStatusV2Directive {
  @Input('appChangeUserStatusV2') user!: IExternalUserListItem;
  @Output() statusChanged = new EventEmitter<void>();

  constructor(
    private usersService: UsersService,
    private confirmationService: ConfirmationService
  ) {}

  @HostListener('mousedown', ['$event']) onMouseDown(event: MouseEvent): void {
    event.preventDefault(); // Block default toggle
    event.stopPropagation();
    if (this.user) {
      const isActive = this.user.isApproved;
      const message = isActive
        ? 'Are you sure that you want to deactivate the user?'
        : 'Are you sure that you want to activate the user?';
      this.confirmationService.confirm({
        message,
        accept: () => {
          this.usersService.updateUserActiveStatus(this.user.userId, !isActive).subscribe(() => {
            this.user.isApproved = !isActive;
            this.statusChanged.emit();
          });
        },
        reject: () => {}
      });
    }
  }
}
